// @flow

import React, { type Node, useEffect } from 'react';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getOneClickCard } from '@tectonics/prs/one-click-card';
import { merchantHasOneClickConfig } from '@tectonics/prs/merchant/config/credit-card-one-click';
import { CardForm } from '../card-form';
import { CardTypeSelector } from './card-type-selector';
import { OneClickForm } from './one-click-form';

export function CreditCardForm(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const oneClickCard = getOneClickCard(incomingPayment);
  const oneClickIsEnabled = merchantHasOneClickConfig(incomingPayment);

  if (!oneClickIsEnabled || !oneClickCard) {
    return <CardForm />;
  }

  return (
    <div>
      <CardTypeSelector />
      <CardFormBasedOnSelectedCardType />
    </div>
  );
}

function CardFormBasedOnSelectedCardType(): Node {
  const [selectedCardType] = useUserInputValue('selectedCardType');
  const [, setCardSecurityCode] = useUserInputValue('cardSecurityCode');

  useEffect(() => {
    if (selectedCardType !== '') {
      setCardSecurityCode('');
    }
  }, [selectedCardType]);

  switch (selectedCardType) {
    case 'oneclick':
      return <OneClickForm />;
    case 'creditcard':
      return <CardForm />;
    default:
      return null;
  }
}
